import {
  Grid
} from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledCardRanking = styled(Grid)<{
  $profilePage: boolean
}>(({
  theme,
  $profilePage
}) => ({
  background: theme.customColors.backgroundCard,
  borderRadius: theme.spacing(2),
  border: `2px solid ${theme.customColors.border}`,
  color: theme.customColors.textWidget,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
  maxHeight: "50rem",
  padding: $profilePage ? theme.spacing(3,4) : theme.spacing(3,2),

  [`${theme.breakpoints.down("sm")}`]: {
    padding: theme.spacing(2)
  }

}));

export const StyledGridUsers = styled(Grid)<{
  $profilePage: boolean
}>(({
  theme,
  $profilePage
}) => ({
  display: "flex",
  flexWrap: "wrap",
  maxHeight: $profilePage ? theme.spacing(90) : theme.spacing(50),
  overflowX: "hidden",
  overflowY: "auto",
  paddingRight: theme.spacing(1),
  "& svg": {
    stroke: theme.customColors.exploreCardText
  },
  "&::-webkit-scrollbar": {
    width: "0.44rem",
    backgroundColor: theme.customColors.exploreCardText,
    borderRadius: "0.5rem"
  },
  "&::-webkit-scrollbar-button": {
    display: "none"
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: theme.customColors.backgroundDisabled,
    borderRadius: "0.5rem"
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: theme.customColors.textPrimaryControl,
    borderRadius: theme.spacing(1)
  },
  [theme.breakpoints.down("sm")]: {
    maxHeight: $profilePage ? theme.spacing(50) : theme.spacing(40)
  }
}));

